import React from 'react';
import { motion, Variants } from 'framer-motion';

const cardVariants: Variants = {
  hidden: { opacity: 0, y: 16 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, delay: i * 0.07, ease: [0.4, 0, 0.2, 1] as const },
  }),
};

interface SectionCardProps {
  title: string;
  sub?: string;
  rightAction?: React.ReactNode;
  children: React.ReactNode;
  index: number;
  id?: string;
  icon?: React.ElementType; // Included for SuperAdmin compatibility
}

export function SectionCard({ title, sub, rightAction, children, index, id, icon: Icon }: SectionCardProps) {
  return (
    <motion.div
      id={id}
      custom={index}
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      style={{
        borderRadius: '0',
        border: '1px solid var(--admin-card-border)',
        backgroundColor: 'var(--admin-card-bg)',
        overflow: 'hidden',
      }}
    >
      <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--admin-card-border)', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {Icon && <Icon size={16} color="var(--admin-card-text)" />}
          <div>
            <h3 style={{ fontSize: '13px', fontWeight: 600, color: 'var(--admin-card-text)', margin: 0 }}>{title}</h3>
            {sub && <p style={{ fontSize: '11px', color: 'var(--admin-card-subtext)', margin: '2px 0 0' }}>{sub}</p>}
          </div>
        </div>
        {rightAction && <div>{rightAction}</div>}
      </div>
      <div>
        {children}
      </div>
    </motion.div>
  );
}
